import { toast } from 'react-toastify';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../Context/AppContext';
import { RootState } from '../../../Redux/Store';
import { useAppDispatch, useAppSelector } from '../../../Hooks/Hooks';
import { getContentStackData } from '../../../Redux/Reducers/ContentOrConfigSlice';
import { updateIsEditSection } from '../../../Redux/Reducers/NatNalSlice';
import { fbLogEvent } from '../../../Helpers/FirebaseHelper';
import { commonDateFormat } from '../../../Utils/DateUtils';
import { EVENT, LEAD, SCREEN } from '../../../Constants/AnalyticsConstants';
import { LOGOUT_TEXT, CANCEL_TEXT, KEYS, CONTENTSTACK_PARAMS } from '../../../Constants/Constants';
import confirm from '../../../../assets/icon/confirm.svg';
import { getContentFromUID } from '../../Support/Support';
import CustomModal, { ETitleWithOption } from '../../../Components/Shared/CustomModal/CustomModal';
import './MoreTab.scss';
import { isEntitled } from '../../../Utils/ContentOrConfigUtil';

const MoreTab = () => {
  const { AppLogout, isMobile } = useContext(AppContext);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { contentStackData, showBanner } = useAppSelector(
    (state: RootState) => state.ContentOrConfig,
  );
  const { lastLocation, nextAvailableLocation, nextAvailableTime } = useAppSelector(
    (state: RootState) => state.NatNal,
  );
  const { memberData } = useAppSelector((state: RootState) => state.member);
  const { configTableData } = useAppSelector((state: RootState) => state.ContentOrConfig);

  useEffect(() => {
    if (!isMobile) navigate('/support');
  }, [isMobile, navigate]);
  useEffect(() => {
    dispatch(
      getContentStackData({
        queryPayload: {
          contentType: 'tabbed_content,accordion_content,tabbed_accordion_content',
        },
      }),
    );
  }, [dispatch]);
  const [logoutModalProps, setLogoutModalProps] = useState({
    isModalOpen: false,
  });
  const [resetPasswordModalProps, setResetPasswordModalProps] = useState({
    isModalOpen: false,
  });
  const handleLogoutButtonClick = () => {
    fbLogEvent(EVENT.SV_LOGOUT_CONFIRMATION, {
      screen: SCREEN.LOGOUT_CONFIRMATION,
      lead: SCREEN.MORE_MENU,
    });
    const temp = {
      isModalOpen: true,
      title: ETitleWithOption.Confirmation,
      titleIcon: confirm,
      additionalCssClass: 'Modal_Logout',
      backdropDismiss: false,
      message: "<div class='my-3'><h3>Are you sure you want to log out?</h3></div>",
      size: 'small-height',
      buttons: [
        {
          title: LOGOUT_TEXT,
          type: 'secondary-cta-btn',
          onClick: () => {
            fbLogEvent(EVENT.UE_LOGOUT_CONFIRM, {
              screen: SCREEN.LOGOUT_CONFIRMATION,
              lead: SCREEN.MORE_MENU,
            });
            AppLogout();
          },
        },
        {
          title: CANCEL_TEXT,
          type: 'primary-cta-btn',
          onClick: () => {
            fbLogEvent(EVENT.UE_LOGOUT_CANCEL, {
              screen: SCREEN.LOGOUT_CONFIRMATION,
              lead: SCREEN.MORE_MENU,
            });
            setLogoutModalProps({ isModalOpen: false });
          },
        },
      ],
    };
    setLogoutModalProps(temp);
  };
  const logFbEvent = (fbEventName: string, fbScreenName: string) => {
    fbLogEvent(fbEventName, {
      screen: fbScreenName,
      lead: LEAD.MORE,
    });
    fbEventName === EVENT.UE_NAT_NAL &&
      fbLogEvent(EVENT.SV_VIEW_NAT_NAL, {
        screen: SCREEN.NAT_NAL,
        lead: LEAD.MORE,
        lastLoadId: lastLocation?.shipmentId,
        nextAvailableTime: commonDateFormat(
          nextAvailableTime,
          false,
          false,
          nextAvailableLocation?.timezone || null,
        ),
        nextAvailableLocation: JSON.stringify({
          locationName: nextAvailableLocation?.locationName,
          addressLine1: nextAvailableLocation?.addressLine1,
          addressLine2: nextAvailableLocation?.addressLine2,
          city: nextAvailableLocation?.city,
          state: nextAvailableLocation?.state,
          postalCode: nextAvailableLocation?.postalCode,
        }),
      });
  };
  const processEventName = (name: string) => {
    if (!name) return '';
    let processedName = name.replace(/[^a-zA-Z0-9 ]/g, ' ');
    processedName = processedName.replace(/\s+/g, '_');
    return processedName.toLowerCase();
  };

  const handleSupportFbEvents = (event: any, content: any) => {
    const subSection =
      getContentFromUID(content?.uid, contentStackData)?.heading ||
      getContentFromUID(content?.uid, contentStackData)?.tab_title ||
      getContentFromUID(content?.uid, contentStackData)?.title;
    const section = event?.tab_title;
    const processedSubSection = processEventName(subSection || '');
    const processedSection = processEventName(section || '');

    fbLogEvent(`ue_${processedSubSection}`, {
      screen: isMobile ? SCREEN.MORE_MENU : SCREEN.SUPPORT,
      lead: SCREEN.MORE_MENU,
      section: processedSection,
      subSection: processedSubSection,
    });
  };
  return (
    <div className={`MoreTab${showBanner ? ' AlertBannerVisible' : ''}`}>
      <CustomModal {...logoutModalProps} />
      <CustomModal {...resetPasswordModalProps} />
      <div
        className="px-3"
        data-testid="ResetPassword"
        onClick={() => {
          fbLogEvent(EVENT.UE_CHANGE_PASSWORD, {
            screen: SCREEN.MORE_MENU,
            lead: SCREEN.MORE_MENU,
          });
          // handleResetPasswordButtonClick();
          toast('Coming soon');
        }}
      >
        <p>Reset Password</p>
        <img src="/oo/assets/icon/change-password.svg" alt="Reset Password" />
      </div>
      <div
        className="px-3"
        onClick={() => {
          fbLogEvent(EVENT.UE_LOGOUT, {
            screen: SCREEN.MORE_MENU,
            lead: SCREEN.MORE_MENU,
          });
          handleLogoutButtonClick();
        }}
      >
        <p>Log out</p>
        <img src="/oo/assets/icon/Logout-Icon.svg" alt="Logout icon" />
      </div>
      <div
        className="px-3"
        onClick={() => {
          fbLogEvent(EVENT.UE_FEEDBACK, {
            screen: SCREEN.MORE_MENU,
            lead: SCREEN.MORE_MENU,
          });
          navigate('/feedback');
        }}
      >
        <p>Feedback</p>
        <img src="/oo/assets/icon/right-arrow.png" alt="Logout icon" />
      </div>
      <div className="Headings">Recommended Capabilities</div>
      <div className="Recommended_Capabilities_Container">
        {isEntitled(
          memberData?.member,
          configTableData?.FPO_APP_CONFIG?.APP_INIT,
          'tab',
          'natNal',
        ) && (
          <>
            <div
              className="px-3"
              data-testid="NatNalComponent"
              onClick={() => {
                logFbEvent(EVENT.UE_NAT_NAL, SCREEN.HOME);
                dispatch(updateIsEditSection(false));
                navigate('/natnal');
              }}
            >
              <p>NAT/NAL</p>
              <img src="/oo/assets/icon/right-arrow.png" alt="NAT/NAL icon" />
            </div>
            <hr />
          </>
        )}
        {isEntitled(
          memberData?.member,
          configTableData?.FPO_APP_CONFIG?.APP_INIT,
          'tab',
          'financialInfo',
        ) && (
          <>
            <div
              className="px-3"
              data-testid="FinancialInfoComponent"
              onClick={() => {
                logFbEvent(EVENT.UE_FINANCIAL_INFO, SCREEN.FINANCIAL_INFO);
                navigate('/financial-info');
              }}
            >
              <p>Financial Info</p>
              <img src="/oo/assets/icon/right-arrow.png" alt="FinancialInfo icon" />
            </div>
            <hr />
          </>
        )}
        <div
          className="px-3"
          data-testid="horizonComponent"
          onClick={() => {
            logFbEvent(EVENT.UE_HORIZON_NAVIGATION, SCREEN.HORIZON);
            window?.open(KEYS?.HORIZON_UI_LINK, '_blank');
          }}
        >
          <p>Horizon</p>
          <img src="/oo/assets/icon/horizon-select.svg" alt="horizon icon" />
        </div>
      </div>
      {contentStackData?.tabbed_content?.find(
      (item: any) => item.uid === CONTENTSTACK_PARAMS.SUPPORT_TABS_UID,
        ).tabs?.map((tab: any) => {
        return (
          <React.Fragment key={tab?.tab_title}>
            <p className="More_Menu_Label">{tab?.tab_title}</p>
            {tab?.content && (
              <div className="Legal_Container px-3">
                {tab?.content?.map((content: any, idx: number) => {
                  return !getContentFromUID(content?.uid, contentStackData) ? null : (
                    <React.Fragment key={content?.uid}>
                      <div
                        onClick={() => {
                          handleSupportFbEvents(tab, content);
                          navigate(`/more-mobile/${tab?.tab_title}/${content?.uid}`);
                        }}
                      >
                        <p>
                          {getContentFromUID(content?.uid, contentStackData)?.heading ||
                            getContentFromUID(content?.uid, contentStackData)?.tab_title ||
                            getContentFromUID(content?.uid, contentStackData)?.title}
                        </p>
                        <img src="/oo/assets/icon/right-arrow.png" alt="Logout icon" />
                      </div>
                      {idx < tab?.content?.length - 1 && <hr />}
                    </React.Fragment>
                  );
                })}
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default MoreTab;
